import React, {useState} from "react";
import {Icon, Modal} from "antd";
import styles from "./index.less";

const ImagePictureCard = ({
  images = [],
}) => {
  const [showModal, setShowModal] = useState(false);
  const [previewImage, setPreviewImage] = useState(undefined);

  const handlePreview = (image) => {
    setPreviewImage(image);
    setShowModal(true);
  };

  const hideModal = () => {
    setShowModal(false);
  };

  let modal = null;

  if (showModal) {
    modal = (
      <Modal visible={true} footer={null} closable={true} onCancel={hideModal} centered={true} width="auto">
        <img src={previewImage.url} alt={previewImage.name || '缩略图'} title="查看原图"/>
      </Modal>
    );
  }

  return (
    <div className={styles["image-card-list"]}>
      {images.map(image => (
        <div className="file-item" key={image.id}>
          <div className="image-wrap">
            <img src={image.url} alt={image.name}/>
          </div>
          <div className="file-actions">
            <Icon type="eye" onClick={() => handlePreview(image)}/>
          </div>
        </div>
      ))}
      {modal}
    </div>
  );
};

export default ImagePictureCard;
